import React from "react";
import { useConfig } from "../../config/ConfigContext";
import DeleteMeal from "./DeleteMeal";
import UpdateQuantityMeal from "./UpdateQuantityMeal";

function Meal({ meal, packageName }) {
  const config = useConfig();
  return (
    <div className="flex justify-between items-start py-2">
      <div className="text-left">
        <h3 className="text-md md:text-lg font-sans text-primary font-light">
          {packageName && meal.fields["quantityInPackage"] + " x "}
          <span className="capitalize">{meal.fields["Name"]}</span>
          {meal.fields["Veggie"] && (
            <img
              src="/assets/img/veggie-icon.png"
              alt="Veggie"
              className="inline ml-2 w-4 h-4"
            />
          )}
        </h3>
        {meal.fields["Description"] && (
          <p className="text-sm text-gray-500 font-extralight max-w-md">
            {meal.fields["Description"]}
          </p>
        )}
      </div>
      <div className="flex items-center">
        <p className="mr-2 text-md md:text-lg text-primary">
          {!packageName && meal.fields[config.itemPriceFieldTTC] + "€"}
        </p>
        {!packageName && (
          <>
            <UpdateQuantityMeal meal={meal} />
            <DeleteMeal meal={meal} />
          </>
        )}
      </div>
    </div>
  );
}

export default Meal;
